<template>
    <div class="blank">
        <group gutter="8">
            <cell title="借款协议" @click="nextRoute('loancontract')">
                <div slot="right">
                        <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
                    </div>
            </cell>
            <cell title="委托代扣协议" @click="nextRoute('paycontract')">
                <div slot="right">
                        <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
                    </div>
            </cell>
        </group>
    </div>    
</template>

<script>
    import {
        Group,
        Cell
    } from 'fiui'

    export default {
        components: {
            Group,
            Cell
        },
        beforeRouteEnter (to, from, next) {
            document.title = '借款协议'
            next()
        },
        methods: {
            nextRoute (route) {
                this.$router.push(route)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// loanlist.vue?1621cf22